import { ServiceError } from './errors'
import type { ServiceName } from './config'

/**
 * Utilidades de los mocks (CLAUDE.md: los mocks simulan latencia y errores para poder ver todos los estados).
 * Códigos de reserva especiales, combinables con los del mock de reserva (`demo`, `hotel`, `fase-*`):
 *  - `error-<servicio>` o `error-todo` → ese servicio (o todos) falla con `server`.
 *  - `offline-<servicio>` o `offline-todo` → falla con `offline`.
 *  - `lento-<servicio>` o `lento-todo` → tarda 4 s (para ver los esqueletos).
 */
const TEST = import.meta.env.MODE === 'test'
export const MOCK_DELAY_MS = TEST ? 0 : 350
export const MOCK_SLOW_MS = TEST ? 30 : 4000

export const delay = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms))

function matches(guestCode: string, prefix: string, service: ServiceName): boolean {
  return guestCode.includes(`${prefix}-${service}`) || guestCode.includes(`${prefix}-todo`)
}

/** Espera la latencia simulada y lanza el error pedido por el código de reserva, si lo hay. */
export async function simulate(guestCode: string, service: ServiceName, signal?: AbortSignal): Promise<void> {
  await delay(matches(guestCode, 'lento', service) ? MOCK_SLOW_MS : MOCK_DELAY_MS)
  if (signal?.aborted) throw new ServiceError('server', 'aborted')
  if (matches(guestCode, 'offline', service)) throw new ServiceError('offline')
  if (matches(guestCode, 'error', service)) throw new ServiceError('server', `mock error (${service})`)
}
